import { useBCMSContext } from "@bcm-dev/bcms-vite";
import { useState } from 'react';
import './styles.css';
export default function IntegrationContainer(props) {
  const globalController = useBCMSContext();

  const bid = globalController.state.b;
  const cid = globalController.state.branding.options.standalone_chw23 =="true" || globalController.state.branding.options.nonfiserv_olb_chw23 === "true"
    ? globalController.state.c 
    : globalController.state.branding.options.parent_courseid_chw23;

  const [contentRef, setContentRef] = useState(null)
  const [src, setSrc] = useState(null)

  let selector = "[chw23_container='true']";
  let loaded = false;
  const href = window.location.href;
  const mountNode = contentRef;
  fetch(`/bcms/php/deploy/ClassModel.php?b=${bid}&c=${cid}`)
    .then(response => response.json())
    .then((jsonData) => {
      let module = jsonData.id ? jsonData.id.toLowerCase() : "";

      switch (module) {
        case "coasp21":

          setSrc(`/bcms/click/coasp21/?b=${bid}&c=${cid}#manage-cards-page`);
          break;
        case "abi22":

          setSrc(`/bcms/click/abi22/?b=${bid}&c=${cid}#/chw23`);
          break;

        case "vbn":
          setSrc(`/bcms/click/vbn/?b=${bid}&c=${cid}/#cardhub-page`);
          break;

        case "architect":
          setSrc(`/click/architect/pages/main/content/cards/cards.php?b=${bid}&c=${cid}&tab=cards`);
          break;
        
        default:
          setSrc(`/bcms/click/chw23/?b=${bid}&c=${cid}#/${ href.split("capture/")[1]}`);
         window.setInterval(function(){
          document.loadFrame();
         },1000)
         
         
          break;
      }



    })
    .catch((error) => {
      // handle your errors here
      console.error(error)
    })
  if (mountNode && loaded === false) {
    const frame = mountNode.contentWindow.window.frames.frameElement.contentWindow.window.frames.frameElement;


    document.demoLoaded = href.split("capture/")[0] + href.split("capture/")[1];
    document.loadFrame = function () {
      mountNode.setAttribute("chw23", "true")

    }
  }



  return (
    <div className={"integration-container"}>
      <iframe ref={setContentRef} src={src} chw23="false" />
    </div>
  );
}
